import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { Input } from 'components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TRSNodeCapacityField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.capacity && touched.capacity}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Capacity</FormLabel>
                <Field
                    name="capacity"
                    render={({ field }) => (
                        <Box className="w-full pt-[15px]">
                            <Input
                                {...field}
                                type="number"
                                placeholder="Enter node capacity"
                                className="!h-[30px] rounded-[5px] pl-2"
                                min="1"
                                step="1"
                                onWheel={(e) => e.target.blur()}
                            />
                        </Box>
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the maximum capacity for this node (must be a positive number)"
                        ariaLabel="node-capacity-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.capacity} touched={touched?.capacity} />
        </FormControl>
    );
};

export default TRSNodeCapacityField;
